<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.editCity") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #d53f07">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Polygon Map -->
          <div class="col-12 mt-4">
            <PolygonMap
              :centerLat="mapCenter.lat"
              :centerLng="mapCenter.lng"
              :initialPaths="polygonPaths"
              @update:paths="handlePaths"
              @update:placeName="handlePlaceName"
            />
          </div>
          <!-- End:: Polygon Map -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PolygonMap from "../../../components/general/PolygonMap.vue";

export default {
  name: "EditCity",
  components: { PolygonMap },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        name_ar: null,
        name_en: null,
        region: null,
        active: null,
      

},
      regions: [],
      polygonPaths: [],
      mapCenter: { lat: 30.0444, lng: 31.2357 },
      paths: [],
      placeName: "",

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // Helper method to convert GeoJSON coordinates to PolygonMap format
    convertBoundaryToPolygonPaths(boundary) {
      if (!boundary || !boundary.coordinates || !boundary.coordinates[0]) {
        return [];
      }

      // GeoJSON coordinates are in [lng, lat] format, we need [lat, lng]
      return boundary.coordinates[0].map((coord) => ({
        lat: coord[1],
        lng: coord[0],
      }));
    },

    // Helper method to calculate center point from polygon paths
    calculateMapCenter(paths) {
      if (!paths || paths.length === 0) {
        return { lat: 30.0444, lng: 31.2357 }; // Default center
      }

      const totalLat = paths.reduce((sum, point) => sum + point.lat, 0);
      const totalLng = paths.reduce((sum, point) => sum + point.lng, 0);

      return {
        lat: totalLat / paths.length,
        lng: totalLng / paths.length,
      };
    },

    // Handle polygon paths updates from the map component
    handlePaths(newPaths) {
      this.paths = newPaths;
    },

    // Handle place name updates from the map component
    handlePlaceName(newPlace) {
      this.placeName = newPlace;
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      if (!this.data.name_ar || !this.data.name_en) {
        if (!this.data.name_ar) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.name_ar"));
          return;
        }
        if (!this.data.name_en) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.name_en"));
          return;
        }
      } else {
        this.submitForm();
      }
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data

      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }

      if (this.paths && this.paths.length > 0) {
        this.paths.forEach((path, index) => {
          REQUEST_DATA.append(`area_points[${index}][lat]`, path.lat);
          REQUEST_DATA.append(`area_points[${index}][lng]`, path.lng);
        });
      }

      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      REQUEST_DATA.append("_method", "PUT");
      try {
        await this.$axios({
          method: "POST",
          url: `cities/${this.$route.params?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/cities/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showCity() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `cities/${this.$route.params?.id}`,
        });

        const cityData = res.data.data.data || res.data.data.City;
        this.data.name_ar = cityData.name_ar;
        this.data.name_en = cityData.name_en;
        this.data.active = cityData.is_active;

        if (cityData.area_points) {
          this.polygonPaths = cityData.area_points.map((point) => ({
            lat: +point.lat,
            lng: +point.lng,
          }));
          this.paths = [...this.polygonPaths];
          this.mapCenter = this.calculateMapCenter(this.polygonPaths);
        }
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
  },

  created() {
    this.showCity();
  },
};
</script>
